import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import './App.css';
import EJILAnimatedLoader from './components/EJILAnimatedLoader';
import Header from './components/Header';
import Footer from './components/Footer';
import HomePage from './pages/Homepage';
import About from './pages/Aboutpage';
import ProductPage from './pages/ProductPage';
import ProductDetail from './pages/ProductDetailPage'
import SolutionPage from './pages/SolutionPage';
import Servicepage from './pages/Servicepage';
import CareerPage from './pages/CareerPage';
import PartnerPage from './pages/PartnerPage';
import ContactUspage from './pages/ContactUspage';
import ComparePage from './pages/ComparePage';
import CloudTelecom from './pages/CloudTelecom';
import AppManagement from './pages/AppManagement';
function App() {
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 2000);

    return () => clearTimeout(timer);
  }, []);

  if (isLoading) {
    return <EJILAnimatedLoader />;
  }

  return (
    <Router>
      <div className="App">
        <Header />
        <main>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/about" element={<About />} />
            <Route path="/solution" element={<SolutionPage />} />
            <Route path="/contactus" element={<ContactUspage />} />
            <Route path="/partners" element={<PartnerPage />} />
            <Route path="/services" element={<Servicepage />} />
            <Route path="/product" element={<ProductPage />} />
            <Route path="/product/:productId" element={<ProductDetail />} />
            {/* <Route path="/product/RUT241" element={<ProductDetail />} /> */}
            <Route path="/product" element={<ProductPage />} />
            <Route path="/compare" element={<ComparePage />} />
            <Route path="/solution/cloud-telecom" element={<CloudTelecom />} />
           <Route path="/solution/app-data-management" element={<AppManagement />} />
            
          </Routes>
        </main>
     
        {/* Decorative shapes */}
        <div className="shape shape-1"></div>
        <div className="shape shape-2"></div>
      </div>
         <Footer />
    </Router>
  );
}

export default App;